module.exports = __webpack_public_path__ + "img/max-good-logo-150x18.4f47e4cf.png";